import _asyncToGenerator from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/opt/build/repo/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ExternalInteractorBase, getDistance, isInArray } from "tsparticles-engine";
import { Slow } from "./Options/Classes/Slow";
export var Slower = /*#__PURE__*/function (_ExternalInteractorBa) {
  _inherits(Slower, _ExternalInteractorBa);

  var _super = _createSuper(Slower);

  function Slower(container) {
    _classCallCheck(this, Slower);

    return _super.call(this, container);
  }

  _createClass(Slower, [{
    key: "clear",
    value: function clear(particle, delta, force) {
      if (particle.slow.inRange && !force) {
        return;
      }

      particle.slow.factor = 1;
    }
  }, {
    key: "init",
    value: function init() {
      var container = this.container,
          slow = container.actualOptions.interactivity.modes.slow;

      if (!slow) {
        return;
      }

      container.retina.slowModeRadius = slow.radius * container.retina.pixelRatio;
    }
  }, {
    key: "interact",
    value: function () {
      var _interact = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function interact() {
        return _interact.apply(this, arguments);
      }

      return interact;
    }()
  }, {
    key: "isEnabled",
    value: function isEnabled(particle) {
      var _a;

      var container = this.container,
          mouse = container.interactivity.mouse,
          events = ((_a = particle === null || particle === void 0 ? void 0 : particle.interactivity) !== null && _a !== void 0 ? _a : container.actualOptions.interactivity).events;
      return events.onHover.enable && !!mouse.position && isInArray("slow", events.onHover.mode);
    }
  }, {
    key: "loadModeOptions",
    value: function loadModeOptions(options) {
      if (!options.slow) {
        options.slow = new Slow();
      }

      for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        sources[_key - 1] = arguments[_key];
      }

      for (var _i = 0, _sources = sources; _i < _sources.length; _i++) {
        var source = _sources[_i];
        options.slow.load(source === null || source === void 0 ? void 0 : source.slow);
      }
    }
  }, {
    key: "reset",
    value: function reset(particle) {
      particle.slow.inRange = false;
      var container = this.container,
          options = container.actualOptions,
          mousePos = container.interactivity.mouse.position,
          radius = container.retina.slowModeRadius,
          slow = options.interactivity.modes.slow;

      if (!slow || !radius || radius < 0 || !mousePos) {
        return;
      }

      var particlePos = particle.getPosition(),
          dist = getDistance(mousePos, particlePos),
          proximityFactor = dist / radius,
          slowFactor = slow.factor;

      if (dist <= radius) {
        particle.slow.inRange = true;
        particle.slow.factor = proximityFactor / slowFactor;
      }
    }
  }]);

  return Slower;
}(ExternalInteractorBase);